<template>
  <settings-modal
    :locked="isLoading"
    class="t-cashback-edit-modal"
  >
    <span
      slot="heading"
      class="font-weight-bold"
    >{{ isNewRate ? 'Add' : 'Edit' }} cashback rate</span>

    <v-layout row>
      <v-flex xs4>
        <v-text-field
          slot="activator"
          v-model="form.amountFrom"
          type="number"
          label="From amount"
          class="t-from-input"
          :disabled="isLoading || isStartRate || !isNewRate"
          :error-messages="getValidationErrorMessage('amountFrom')"
        />
      </v-flex>
      <v-flex xs4>
        <v-text-field
          v-model="form.rate"
          type="number"
          label="Rate"
          suffix="%"
          class="t-rate-input"
          :disabled="isLoading"
          :error-messages="getValidationErrorMessage('rate')"
        />
      </v-flex>
    </v-layout>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        class="t-save-button"
        color="primary"
        medium
        flat
        :disabled="!isFormFilled || isLoading"
        @click="onSaveButtonClick"
      >Save</v-btn>

      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        :disabled="isLoading"
        @click="onCloseButtonClick"
      >cancel</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import SettingsModal from '@/components/modals/SettingsModal.vue'
  import modal from '@/mixins/modal'
  import { mapActions, mapGetters } from 'vuex'
  import form from '@/mixins/form'
  import ErrorAlert from '@/components/ui/ErrorAlert.vue'
  import round from 'lodash/round'

  export default {
    name: 'CashbackEditModal',
    components: {
      ErrorAlert,
      SettingsModal
    },
    mixins: [form, modal],
    data () {
      return {
        error: null,
        isLoading: false,
        requiredFields: ['amountFrom', 'rate'],
        form: {
          amountFrom: null,
          rate: null
        }
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      rateFormData () {
        return this.modal.data.formData
      },
      isNewRate () {
        return this.modal.data.isNewRate
      },
      isStartRate () {
        return this.rateFormData.amountFrom === 0
      }
    },
    created () {
      this.setFormData({
        amountFrom: this.rateFormData.amountFrom ?? null,
        rate: this.rateFormData.rate ?? null
      })
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onSaveButtonClick () {
        this.modal.data.updateCallback((execute) => {
          this.setError(null)
          this.setIsLoading(true)

          execute(this.formDataToRequestData(this.form))
            .then(() => this.closeModal())
            .catch((error) => this.setError(error))
            .finally(() => this.setIsLoading(false))
        })
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      formDataToRequestData (formData) {
        const rate = round(formData.rate / 100, 5)
        const amountFrom = Number(formData.amountFrom)

        return {
          amountFrom: isNaN(amountFrom) ? formData.amountFrom : amountFrom,
          rate: isNaN(rate) ? formData.rate : rate
        }
      },
      setIsLoading (isLoading) {
        this.$set(this, 'isLoading', isLoading)
      }
    }
  }
</script>
